export default "__VITE_PUBLIC_ASSET__5d448323__"